import { render, staticRenderFns } from "./EmployeeSalarySlip.vue?vue&type=template&id=4784ed9e&scoped=true"
import script from "./EmployeeSalarySlip.vue?vue&type=script&lang=js"
export * from "./EmployeeSalarySlip.vue?vue&type=script&lang=js"
import style0 from "./EmployeeSalarySlip.vue?vue&type=style&index=0&id=4784ed9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4784ed9e",
  null
  
)

export default component.exports